import type { FunctionComponent, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { IUserProfilesEnumsVerificationStatus } from '../../../account/queries/profile.graphql';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { slugify } from '../../../shared/utils/strings';
import { RequirementsInfo } from '../requirements-info/requirements-info';

import styles from './verification-title-and-info.module.scss';

const style = createStyleHelper(styles, 'verification-title-and-info');

export interface IVerificationTitleAndInfoProps {
    className?: string;
    translationId: string;
    translationDefault: string;
    accountStatus: IUserProfilesEnumsVerificationStatus | null;
}

export const VerificationTitleAndInfo: FunctionComponent<IVerificationTitleAndInfoProps> = ({
    className,
    translationId,
    translationDefault,
    accountStatus,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            <h2 className={style('account')}>
                <FormattedMessage
                    id={translationId}
                    defaultMessage={translationDefault}
                    values={{
                        'status': accountStatus,
                        'account-status': (status: ReactNode[]) => {
                            return (
                                <span
                                    className={style('account-status', {
                                        'verified':
                                            status[0] ===
                                            IUserProfilesEnumsVerificationStatus.Verified,
                                        'not-verified':
                                            status[0] ===
                                                IUserProfilesEnumsVerificationStatus.NotSet ||
                                            status[0] ===
                                                IUserProfilesEnumsVerificationStatus.Failed ||
                                            status[0] ===
                                                IUserProfilesEnumsVerificationStatus.NotMatched,
                                        'pending':
                                            status[0] ===
                                                IUserProfilesEnumsVerificationStatus.Pending ||
                                            status[0] ===
                                                IUserProfilesEnumsVerificationStatus.VerifiedPartial,
                                    })}
                                >
                                    <FormattedMessage
                                        id={`account.verification.status.${slugify(
                                            status[0] as string,
                                        )}`}
                                        defaultMessage={status[0] as string}
                                    />
                                </span>
                            );
                        },
                    }}
                />
            </h2>
            <div className={style('message-text')}>
                <RequirementsInfo />
            </div>
        </div>
    );
};
